import { Component, OnInit } from '@angular/core';
import { ActivitylogService } from '../activitylog/activitylog.service';
import { type } from 'os';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';

//import { from } from 'rxjs';
@Component({
  selector: 'app-activitylog',
  templateUrl: './activitylog.component.html',
  styleUrls: ['./activitylog.component.css']
})
export class ActivitylogComponent implements OnInit {

  constructor(private activelog: ActivitylogService, private toastr: ToastrService, private SpinnerService: NgxSpinnerService,
    private datepipe: DatePipe, ) { }

  sendMenuId: number;
  sendPageName: string = 'Activity log';
  activelogList: any[] = []; p: number = 1; q: number = 1;
  itemsPerPageText: number = 10; totalListCount: number = 0; activeTab: string = 'document';
  key: string = 'database'; key1: string = 'database'; requestreverse: boolean = false;
  reverse: boolean = false;
  filterShowDoc = false;
  filterShowReq = false;
  searchCondition = '';
  sortCondition = '';
  sortDirection = '';
  tableHeaderDoc = [
    { label: '#', key: '', search: '' },
    { label: 'Database', key: 'database', search: '' },
    { label: 'Form Name', key: 'formconfigname', search: '' },
    { label: 'Document ID', key: 'documentid', search: '' },
    { label: 'Author', key: 'firstname', search: '' },
    { label: 'Action', key: 'status', search: '' },
    { label: 'Date And Time', key: 'createdon', search: '' }
  ];
  tableHeaderReq = [
    { label: '#', key: '', search: '' },
    { label: 'Database', key: 'database', search: '' },
    { label: 'Request Type', key: 'requesttype', search: '' },
    { label: 'Request ID', key: 'requestdetailid', search: '' },
    { label: 'Author', key: 'firstname', search: '' },
    { label: 'Action', key: 'status', search: '' },
    { label: 'Date And Time', key: 'createdon', search: '' }
  ];

  ngOnInit() {

    // this.getActiveLogcount(this.activeTab);
    // this.onTabChange('document');
    this.getActivityLog();
    // this.onTabChange('request')
  }

  getActiveLogcount(type) {
    this.activelog.getActivityLogCount(type).subscribe(res => {

      this.totalListCount = JSON.parse(res[0].j);
      this.totalListCount = this.totalListCount[0].count;

    });
  }

  changeitemsperpage(eve) {
    this.itemsPerPageText = eve.currentTarget.value;
    this.activeTab == 'document' ? this.p = 1 : this.q = 1;
    this.removeCodn();
    this.activelogList = [];
    this.setSearchCondition();
    // this.onTabChange(this.activeTab);
  }

  getPage(page: number, type: string) {
    if (type == 'document') {
      this.p = page;
    }
    if (type == 'request') {
      this.q = page;
    }
    this.setSearchCondition();

    // this.onTabChange(this.activeTab);
  }

  // onTabChange(type) {
  //   this.SpinnerService.show();
  //   this.activeTab = type;
  //   this.getActiveLogcount(this.activeTab);
  //   this.activelogList = [];
  //   var pagenumber = 1;

  //   if (type == 'document') {
  //     pagenumber = this.p;
  //   }

  //   if (type == 'request') {
  //     pagenumber = this.q;
  //   }

  //   this.activelog.getActivityLog(type, pagenumber, this.itemsPerPageText, null, null).subscribe(res => {
  //     this.activelogList = res;
  //     this.activelogList = JSON.parse(this.activelogList[0].j);
  //     // this.rowsData = this.activelogList;
  //     this.SpinnerService.hide();
  //     // this.activelog
  //   }, err => {
  //     this.toastr.error('Error while updating status');
  //   });
  // }



  onTabChange(type) {
    
    this.removeCodn();
    this.activeTab = type;
    this.activelogList = [];
    this.getActivityLog();
  }

  // sort(key, typeOfSort) {


  //   if (typeOfSort === 'documentlistsort') {
  //     this.key = key;
  //     this.reverse = !this.reverse;
  //   }
  //   if (typeOfSort === 'requestlistlistsort') {
  //     this.key1 = key;
  //     this.requestreverse = !this.requestreverse;
  //   }

  // }


  sort(key) {
    var sortDirection = '';
    if (this.key != key) {
      this.sortDirection = 'asc';
    } else {
      this.sortDirection = this.sortDirection === 'desc' ? 'asc' : 'desc';
    }
    this.key = key;
    this.reverse = this.sortDirection === 'desc';
    this.sortCondition = '';

    if (key == 'createdon') {
      this.sortCondition = 'cast(' + this.getDBKey(this.key).toLowerCase() + ' as date)' + ' ' + this.sortDirection;
    } else {
      this.sortCondition = this.getDBKey(this.key).toLowerCase() + ' ' + this.sortDirection;
    }



    // this.sortCondition = 'c.' + this.key.toLowerCase() + ' ' + this.sortDirection;
    this.setSearchCondition();





  }


  postDateChange(eve, key) {
    
    let header = [];
    header = this.activeTab == 'document' ? this.tableHeaderDoc : this.tableHeaderReq;
    header.forEach(element => {
      if (element.key == key) {
        if (eve != null && eve.length > 0) {
          element.search = eve;
        } else {
          element.search = '';
        }
      }
    });
    this.setSearchCondition();
  }

  keypress(event) {
    
    if (event == 13) {
      this.activeTab == 'document' ? this.p = 1 : this.q = 1;
      this.setSearchCondition();
    }
  }

  removeSearchCondition() {
    this.removeCodn();
    this.activeTab == 'document' ? this.p = 1 : this.q = 1;
    this.setSearchCondition();
    // this.getArbitrationData();
  }


  removeCodn() {
    let header = [];
    header = this.activeTab == 'document' ? this.tableHeaderDoc : this.tableHeaderReq;
    header.forEach(element => {
      element.search = '';
    });
    this.sortCondition = '';
    this.searchCondition = '';
    this.sortCondition = '';
    this.sortDirection = 'asc';
    if (this.activeTab == 'document') {
      this.filterShowDoc = false;
      this.p = 1;
    } else {
      this.filterShowReq = false;
      this.q = 1;
    }
    this.reverse = false;
  }


  getActivityLog() {
    
    this.SpinnerService.show();
    const countModel = {
      active_p: 1,
      requesttype_p: this.activeTab,
      pageno_p: 0,
      itemsperpage_p: 0,
      mode_p: 'getcount',
      sorting_p: null,
      searchcondition_p: this.searchCondition == '' ? null : this.searchCondition

    };
    this.activelog.getActivityLogData(countModel).subscribe(countResponse => {
      let count = JSON.parse(countResponse.body[0].j);
      if (countResponse != undefined && countResponse != null && count[0].count != undefined && count[0].count != null) {
        this.totalListCount = count[0].count;
        if (this.totalListCount > 0) {
          const getModel = {
            pageno_p: this.activeTab == 'document' ? this.p : this.q,
            itemsperpage_p: parseInt(this.itemsPerPageText.toString(), 10),
            mode_p: 'getall',
            sorting_p: this.sortCondition == '' ? null : this.sortCondition,
            searchcondition_p: this.searchCondition == '' ? null : this.searchCondition,
            active_p: 1,
            requesttype_p: this.activeTab
          };

          this.activelog.getActivityLogData(getModel).subscribe(getResponse => {
            console.log('getResponse: ', getResponse);
            this.activelogList = [];
            let activityLog = getResponse.body;
            if (JSON.parse(activityLog[0].j) != null && activityLog[0].j.length > 0) {
              activityLog = JSON.parse(activityLog[0].j);
              this.activelogList = activityLog;
            }
            this.SpinnerService.hide();
          }, error => {
            this.SpinnerService.hide();
            this.toastr.error('Not able to get Activity Log Data');
          });

        } else {
          this.activelogList = [];
          this.SpinnerService.hide();
        }
      } else {
        this.activelogList = [];
        this.SpinnerService.hide();
      }
    }, err => {
      this.SpinnerService.hide();
      this.toastr.error('Not able to get Activity Log Data');
    });


  }


  setSearchCondition() {
    let searchCondition = '';
    let header = [];
    header = this.activeTab == 'document' ? this.tableHeaderDoc : this.tableHeaderReq;
    header.forEach(element => {
      if (element.key != '') {
        if (element.key != 'createdon' && element.key != 'requestdetailid' && element.key != 'documentid') {
          if (searchCondition == '' && element.search != '' && element.search != null) {
            searchCondition = ' and lower(' + this.getDBKey(element.key) + ') like "%' + element.search.replace('\'', '\'\'').trim().toLowerCase() + '%"';
          } else if (element.search != '' && element.search != null) {
            // tslint:disable-next-line: max-line-length
            searchCondition = searchCondition + ' and ' + 'lower(' + this.getDBKey(element.key) + ') like "%' + element.search.replace('\'', '\'\'').trim().toLowerCase() + '%"';
          }
        } else if (element.key == 'createdon' && element.key != 'requestdetailid' && element.key != 'documentid') {
          console.log('createdon', element.search);
          if (searchCondition == '' && element.search != '' && element.search != null) {
            searchCondition = ' and cast(' + this.getDBKey(element.key) + ' as date)' + ' between "' + this.datepipe.transform(new Date(element.search[0]), 'yyyy-MM-ddTHH:MM:SS') + '"' + ' and ' + '"' + this.datepipe.transform(new Date(element.search[1]), 'yyyy-MM-ddTHH:MM:SS') + '"';
          }
          else if (element.search != '' && element.search != null) {
            searchCondition = searchCondition + ' and cast(' + this.getDBKey(element.key) + ' as date)' + ' between "' + this.datepipe.transform(new Date(element.search[0]), 'yyyy-MM-ddTHH:MM:SS') + '"' + ' and ' + '"' + this.datepipe.transform(new Date(element.search[1]), 'yyyy-MM-ddTHH:MM:SS') + '"';
          }
        } else if (element.key == 'requestdetailid' || element.key == 'documentid') {
          if (searchCondition == '' && element.search != '' && element.search != null) {
            searchCondition = ' and cast(' + this.getDBKey(element.key) + ' as text) like "%' + element.search.replace('\'', '\'\'').trim().toLowerCase() + '%"';
          } else if (element.search != '' && element.search != null) {
            // tslint:disable-next-line: max-line-length
            searchCondition = searchCondition + ' and ' + 'cast(' + this.getDBKey(element.key) + ' as text) like "%' + element.search.replace('\'', '\'\'').trim().toLowerCase() + '%"';
          }
        }
      }
    });
    this.searchCondition = searchCondition;
    this.getActivityLog();
  }


  getDBKey(key) {
    switch (key) {
      case 'firstname':
        return this.activeTab == 'document' ? 'u.firstname' : 'd.firstname';
      case 'status':
        return this.activeTab == 'document' ? 's.status' : 'd.status';
      case 'database':
        return this.activeTab == 'document' ? 'db.database' : 'd.database';
      case 'formconfigname':
        return 'fm.formconfigname';
      default:
        return 'd.' + key;
    }
  }

}
